module.exports = __webpack_public_path__ + "static/media/InfoIcon.5d6bc5ac.svg";